import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';

export const MoreWorks = () => {
  const { t } = useTranslation('private');

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6">
      <div className="mx-auto flex w-full max-w-md flex-col items-center justify-center">
        <p className="w-full text-balance text-center font-bold text-white">
          {t('moreWorks.title')}
        </p>
        <p className="w-full text-balance text-center text-white">
          {t('moreWorks.body')}
        </p>
      </div>

      <Button
        as="a"
        className="mt-6"
        href="/"
        label={t('moreWorks.buttonText')}
        target="_blank"
        variant="secondary"
      />
    </div>
  );
};
